<template>
	<div class="InventoryAccountSetup">
		<div class="InventoryAccountSetup__card">
			<div class="InventoryAccountSetup__card--content">
				<div class="InventoryAccountSetup__card--top">
					<!-- <p>
						<span class="text-teal">
							Number of days left for Free Trial:
						</span>
						28
					</p> -->
					<div class="InventoryAccountSetup__card--top-center">
						<p class="text-teal cursor-pointer">
							Upgrade
						</p>
						<p class="mt-4 text-xl">
							Welcome to NymbleUp
						</p>
					</div>
					<!-- <p>
						<span class="text-teal">&nbsp;</span>
					</p> -->
				</div>
				<div class="text-center text-base">
					<p>
						Contact your system administrator to understand hoe to add data
					</p>
					<p>
						To start using platform please follow the following steps
					</p>
				</div>

				<div class="InventoryAccountSetup__starting--steps ">
					<!-- <div>Select Store</div>
          <el-select
            v-model="selectedOutletId"
            placeholder="Select Store"
          >
            <el-option
              v-for="outlet in outlets"
              :key="outlet.id"
              :label="outlet.name"
              :value="outlet.id"
            />
          </el-select> -->
					<div class="InventoryAccountSetup__all--steps">
						<p class="text-base text-black">
							<span class="text-teal text-xl">Step 1 :</span>
							Add Current Inventory
							<br />
						</p>
						<!-- <span class="text-sm ml-16 w-1/2">Add Current Inventory</span> -->

						<button
							class="InventoryAccountSetup__steps--btn"
							@click="$router.push({ name: 'AppUploadCsvOrAddStoreDetails' }).catch(()=>{})"
						>
							Upload Inventory
						</button>
					</div>
					<div class="InventoryAccountSetup__all--steps">
						<p class="text-base text-black">
							<span class="text-teal text-xl">Step 2 :</span>
							Set Stock Count Calendar
							<br />
						</p>
						<!-- <span class="text-sm ml-16 w-1/2">Add Current Inventory</span> -->

						<button
							class="InventoryAccountSetup__steps--btn"
							@click="$router.push({ name: 'AppUploadCsvOrAddStoreDetails' }).catch(()=>{})"
						>
							Set Calender
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "InventoryAccountSetup",
	data() {
		return {};
	}
};
</script>
<style lang="scss">
@import "./InventoryAccountSetup.scss";
</style>
